import { request } from ".";

export const getExampleCollaboratorMassiveXlsxForDownload = async (): Promise<any> => {
    const response = await request.get<any>(`/assets/public/Exemplo%20Cadastro%20Colaboradores%20Eezycare%20One.xlsx`, {
        responseType: "blob",
    });

    if (!response.data) {
        return null
    }

    return response.data;
}